<script setup lang="ts">
import type { PropType } from 'vue'
import type { AdminMetersDataType } from '@/entities/Cabinet'
import { useModel } from './../model/model'
import { assign, pick } from 'lodash'

const props = defineProps({
  item: {
    type: Object as PropType<AdminMetersDataType>,
    required: false,
  },
  replace: {
    type: Number,
    required: false,
  },
})

const model = useModel()

const clickHandler = () => {
  if (props.item) {
    model.data = assign(model.data, pick(props.item, Object.keys(model.data)))
  } else if (props.replace) {
    model.replaceId = props.replace
    model.data = { ...model.fields }
  } else {
    model.data = { ...model.fields }
  }

  model.openForm = true
}
</script>

<template>
  <span @click="clickHandler">
    <slot />
  </span>
</template>
